"use client";

import ImageWithSkeleton from "@/components/ui/ImageWithSkeleton";
import { useSignedUrl } from "@/hooks/useSignedUrl";
import { ICertificate } from "@/types";
import { Award } from "lucide-react";

interface CertificateCardProps {
    certificate: ICertificate;
    onClick?: (certificate: ICertificate) => void;
}

const CertificateCard = ({ certificate, onClick }: CertificateCardProps) => {
    const { signedUrl, isLoading } = useSignedUrl(certificate.image?._id);

    const handleClick = (e: React.MouseEvent) => {
        if (onClick) {
            e.preventDefault();
            onClick(certificate);
        }
    };

    return (
        <div
            onClick={handleClick}
            className="group relative flex h-full cursor-pointer flex-col justify-between gap-3 rounded-2xl border border-border-color bg-card-bg p-4 shadow-sm transition hover:border-primary hover:shadow-md"
        >
            <ImageWithSkeleton
                src={signedUrl}
                alt={certificate.title}
                isLoadingUrl={isLoading}
                width={0}
                height={0}
                sizes="100vw"
                containerClassName="mb-1 aspect-[4/3] w-full rounded-xl border border-border-color bg-background-color"
                className="h-full w-full rounded-xl object-contain p-1"
            />
            <div className="flex min-w-0 items-center gap-2">
                <Award className="size-4 shrink-0 text-primary" />
                <h3 className="break-words text-sm font-bold text-text-color transition group-hover:text-primary sm:text-base">
                    {certificate.title}
                </h3>
            </div>
        </div>
    );
};

export default CertificateCard;
